import { Icon } from '@iconify/react';
import { PATH_DASHBOARD } from '../../../routes/paths';


const navConfig = [
  {
    items: [
      { title: 'Dashboard', path: '/dashboard/home', icon:<Icon icon="ri:dashboard-line" /> },
      { title: 'Category', path: PATH_DASHBOARD.category.category, icon: <Icon icon="material-symbols:category"/> },
      // { title: 'Bundles', path: PATH_DASHBOARD.bundles.bundles, icon: <Icon icon="material-symbols:inbox" /> },
      { title: 'Card', path: PATH_DASHBOARD.cards.cards, icon: <Icon icon="octicon:organization-16" /> },
      // { title: 'Customer',  path: PATH_DASHBOARD.spell.spell , icon:<Icon icon="ri:dashboard-line" /> },
      // { title: 'Queries', path: PATH_DASHBOARD.dorm.dorm, icon: <Icon icon="material-symbols-light:subscriptions-rounded" /> },
      // { title: 'Lead', path: PATH_DASHBOARD.lead.lead, icon: <Icon icon="material-symbols-light:subscriptions-rounded" /> },
      // { title: 'Area', path: PATH_DASHBOARD.area.area, icon: <Icon icon="material-symbols-light:subscriptions-rounded" /> },
      { title: 'Orders', path: PATH_DASHBOARD.order.order, icon: <Icon icon="material-symbols-light:subscriptions-rounded" /> },
    ],
  },

];

export default navConfig;
